<template>
  <v-container fluid class="pa-0 ma-0">
    <v-card class="elevation-0 rounded-lg">
      <v-row class="px-4">
        <v-col class="sm-6">
          <h3 class="mb-2">Start Date</h3>
          <v-card flat outlined class="px-4">
            <v-row>
              <v-col class="sm-6">
                <v-select
                  data-testid="current-agent-leads-start-month-menu"
                  class="current-agent-leads-start-month-menu mt-2"
                  v-model="selectedStartMonth"
                  :items="months"
                  label="Month"
                />
              </v-col>
              <v-col class="sm-6">
                <v-select
                  data-testid="current-agent-leads-start-year-menu"
                  class="current-agent-leads-start-year-menu mt-2"
                  v-model="selectedStartYear"
                  :items="years"
                  label="Year"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col>
          <h3 class="mb-2">End Date</h3>
          <v-card flat outlined class="px-4">
            <v-row>
              <v-col class="sm-6">
                <v-select
                  data-testid="current-agent-leads-end-month-menu"
                  class="current-agent-leads-end-month-menu mt-2"
                  v-model="selectedEndMonth"
                  :items="months"
                  label="Month"
                />
              </v-col>
              <v-col class="sm-6">
                <v-select
                  data-testid="current-agent-leads-end-year-menu"
                  class="current-agent-leads-end-year-menu mt-2"
                  v-model="selectedEndYear"
                  :items="years"
                  label="Year"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-layout class="mt-2 px-4">
        <v-btn
          data-testid="current-agent-leads-update-btn"
          class="current-agent-leads-update-btn mt-2"
          color="primary"
          @click="getCurrentAgentLeads"
          block
        >
          Update
        </v-btn>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="dealsList"
        :loading="loading"
        :server-items-length="dealCount"
        class="mt-6"
        :options.sync="pagination"
        no-data-text="No deals found"
        loading-text="Loading deals..."
        style="overflow: auto"
      >
      <template v-slot:[`item.date`]="{ item }">
        <td>{{ formattedDate(item.created_at) }}</td>
      </template>
      <template v-slot:[`item.locationCode`]="{ item }">
        <td>{{ item.facility.location_code }}</td>
      </template>
      <template v-slot:[`item.firstName`]="{ item }">
        <td>{{ item.customer_first_name }}</td>
      </template>
      <template v-slot:[`item.lastName`]="{ item }">
        <td>{{ item.customer_last_name }}</td>
      </template>
      <template v-slot:[`item.phoneNumber`]="{ item }">
        <td>{{ item.customer_phone }}</td>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <td>{{ getStatus(item.type, item.pending) }}</td>
      </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { currentAgentLeadsHeaders } from "@/helpers/deals-phone-rentals/current-agent-leads-data-table-headers";
import moment from "moment";
import { monthsList } from "@/helpers/months-list";
import { yearsList } from "@/helpers/dropdown-years";

export default {
  data() {
    return {
      search: "",
      headers: currentAgentLeadsHeaders,
      months: monthsList,
      years: yearsList,
      loading: false,
      pagination: {},
      selectedStartMonth: moment().format("MM"),
      selectedStartYear: moment().year(),
      selectedEndMonth: moment().format("MM"),
      selectedEndYear: moment().year()
    };
  },

  // ===== Methods ===== //
  methods: {
    formattedDate(dateString) {
      return moment(dateString).format("M/D/YYYY");
    },
    getStatus(type, pending) {
      if (type !== 3 && !pending) {
        return "Cancelled";
      }
      switch (type) {
        case 1:
          return "Lead";
        case 2:
          return "Reservation";
        case 3:
          return "Converted";
        default:
          return "N/A";
      }
    },
    getCurrentAgentLeads() {
      this.loading = true;
      let params = {
        page: this.pagination.page,
        per_page: this.pagination.itemsPerPage,
        start_date: this.selectedStartDate,
        end_date: this.selectedEndDate
      };
      this.$store.dispatch("getCurrentAgentLeads", params).then(() => {
        this.loading = false;
      });
    }
  },

  // ===== Computed ===== //
  computed: {
    dealsList() {
      return this.$store.state.user.leads.data;
    },
    dealCount() {
      return this.$store.state.user.leads.total;
    },
    selectedStartDate() {
      return this.selectedStartMonth + "-" + this.selectedStartYear;
    },
    selectedEndDate() {
      return this.selectedEndMonth + "-" + this.selectedEndYear;
    },
    agents() {
      return this.$store.getters.agents;
    }
  },
  // ==== Watchers ==== //

  watch: {
    pagination: {
      handler() {
        this.getCurrentAgentLeads();
      },
      deep: true
    }
  },

  // ===== Lifecycle Hooks ===== //
  mounted() {}
};
</script>

<style scoped>
</style>
